import React from 'react';

interface CalendarTitleProps {
  title: string;
  onClick?: () => void;
  className?: string;
}

export const CalendarTitle: React.FC<CalendarTitleProps> = ({
  title,
  onClick,
  className = '',
}) => {
  const isClickable = Boolean(onClick);

  return (
    <div
      className={`
        flex items-center justify-center
        w-[220px]
        px-4 py-2
        text-lg font-semibold
        text-gray-800
        text-center
        ${isClickable ? 'cursor-pointer hover:bg-gray-100 rounded-md transition-colors duration-200' : ''}
        ${className}
      `}
      onClick={onClick}
      role={isClickable ? 'button' : undefined}
      tabIndex={isClickable ? 0 : undefined}
      onKeyDown={isClickable ? (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onClick?.();
        }
      } : undefined}
    >
      {title}
    </div>
  );
};